import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { REFERENCIALS_URL, useGetReferentialsAsync } from '@/features/shared/apis';

import { GetVehicleTypesReferentialResponse } from '../types';

export const useVehicleTypesOptions = () => {
  const { t } = useTranslation('vehicle_types');
  const { data: vehicleTypesResponse, isLoading: isGetVehicleTypesLoading } =
    useGetReferentialsAsync<GetVehicleTypesReferentialResponse>(REFERENCIALS_URL.VEHICLE_TYPE_REFERENTIAL);

  const vehicleTypesOptions = useMemo(() => {
    const vehicleTypes = vehicleTypesResponse?.vehicleTypes ?? [];
    const index = vehicleTypes.findIndex((v) => v.code === '395');

    if (index > 0) {
      // Extraire l'élément et le mettre en premier
      const [item] = vehicleTypes.splice(index, 1);
      vehicleTypes.unshift(item);
    }

    return vehicleTypes.map((vehicleType) => ({
      label: t(`VEHICLE_TYPE_${vehicleType.descriptionTranslationKey}`),
      value: vehicleType.id,
    }));
  }, [t, vehicleTypesResponse?.vehicleTypes]);

  return {
    isGetVehicleTypesLoading,
    vehicleTypesOptions,
  };
};
